import { DocumentNode, gql } from '@apollo/client';

// Statisches Dokument mit GraphQL-Variablen (keine String-Interpolation mehr).
export const getCountryByCountryCodeQuery: DocumentNode = gql`
  query GetCountryByCountryCode($countryCode: String!) {
    countryByCountryCode(countryCode: $countryCode) {
      id,
      name,
      countryCode,
      logisticType {
        id,
        name,
      },
      localPartnerEmail,
      tesShipperNumber,
      recipient {
      id,
      name,
      city {
      id,
      postalCode,
      name,
      }
      street,
      houseNumber,
      phoneNumber,
      countryCode,
    },
    }
  }
`;
